import { CGI_TYPE } from "../../interfaces/common/ICgiOption";
import { get } from "lodash-es";
export function isFrontEndCgi(cgiInfo) {
  return get(cgiInfo, 'cgiType') === CGI_TYPE.FrontEndHttp;
}
//# sourceMappingURL=isFrontEndCgi.js.map
